import React from "react";

const MAP = {
  AVAILABLE: { label: "Available", cls: "bg-emerald-900/10 text-emerald-800 border-emerald-700/30", dot: "bg-emerald-600" },
  LIMITED: { label: "Limited", cls: "bg-amber-900/10 text-amber-800 border-amber-700/40", dot: "bg-amber-500" },
  ON_REQUEST: { label: "On Request", cls: "bg-stone-900/10 text-stone-700 border-stone-600/30", dot: "bg-stone-500" },
  SOLD_OUT: { label: "Sold Out", cls: "bg-rose-900/10 text-rose-800 border-rose-700/30", dot: "bg-rose-600" },
};

export const StockBadge = ({ status, testId }) => {
  const s = MAP[status] || MAP.ON_REQUEST;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-mono font-semibold uppercase tracking-wider ${s.cls}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
};

export default StockBadge;
